<template>
  <BCard>
    <div class="text-black text-2xl font-medium mb-2">
      Verifikasi Partner
    </div>
    <BRow>
      <Card
        :icon="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/profile-2user.svg'"
        :title="'Total Pengajuan'"
        :tooltip="'Total jumlah partner yang dalam status Verifikasi “Request”, “Disetujui”, dan “Ditolak'"
        :total="analytic.total"
        :target="'total-pengajuan'"
      />
      <Card
        :icon="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/user-search.svg'"
        :title="'Request Verifikasi'"
        :tooltip="'Partner yang mengajukan verifikasi'"
        :total="analytic.total_requested"
        :target="'request-verifikasi'"
      />
      <Card
        :icon="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/user-tick.svg'"
        :title="'Partner Terverifikasi'"
        :tooltip="'Partner yang proses pengajuannya sudah terverifikasi'"
        :total="analytic.total_approved"
        :target="'partner-terverifikasi'"
      />
      <Card
        :icon="'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/user-remove.svg'"
        :title="'Verifikasi Ditolak'"
        :tooltip="'Pengajuan verifikasi yang ditolak oleh admin'"
        :total="analytic.total_rejected"
        :target="'verifikasi-ditolak'"
      />
    </BRow>
    <BRow class="mb-2 items-center justify-between">
      <BCol
        lg="3"
        md="12"
        sm="12"
        class="text-black text-2xl font-medium mb-2 mb-lg-0"
      >
        Data Partner
      </BCol>
      <BCol
        lg="9"
        md="12"
        sm="12"
      >
        <div class="flex md:flex-row flex-col flex-nowrap gap-3 items-center w-full">
          <div class="flex rounded-lg items-center border bg-white px-1 h-[38px] w-full">
            <span
              class="k-search-normal-1 font-bold align-middle mx-[5px] text-[#828282]"
              style="font-size: 20px"
            />
            <BFormInput
              v-model="search"
              placeholder="Cari nama atau email"
              class="border-0 shadow-none px-1 h-[34px]"
              @input="searchData"
            />
          </div>
          <DateRangePicker
            ref="picker"
            v-model="dateRange"
            :locale-data="locale"
            :ranges="false"
            :opens="'left'"
            class="w-full"
          >
            <template v-slot:input="picker">
              <div class="flex items-center justify-between gap-1 w-full overflow-hidden h-[24px]">
                <span class="whitespace-nowrap text-[12px] sm:text-[13px] font-medium leading-none truncate">
                  {{ DDMMYYYY(picker.startDate) }} - {{ DDMMYYYY(picker.endDate) }}
                </span>
                <BImg
                  src="https://storage.googleapis.com/komerce/assets/icons/calendar.png"
                  class="flex-shrink-0 w-5 h-5"
                />
              </div>
            </template>
          </DateRangePicker>
          <v-select
            v-model="product"
            label="text"
            :options="optionsOfProduct"
            :reduce="option => option.value"
            :clearable="false"
            class="w-full"
          >
            <template v-slot:option="option">
              <div class="d-flex items-center">
                <img
                  v-if="option.value !== ''"
                  class="mr-1 w-6 h-6 object-contain"
                  :src="option.src"
                  :alt="option.value"
                >
                {{ option.text }}
              </div>
            </template>
          </v-select>
          <BFormSelect
            v-model="status"
            :options="statusOptions"
            placeholder="Status"
            class="w-full h-[38px]"
          />
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            size="md"
            class="text-nowrap w-fit h-[38px] flex items-center justify-center"
            @click="resetFilter()"
          >
            Reset Filter
          </b-button>
        </div>
      </BCol>
    </BRow>
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        style="height: calc(100vh - 400px); overflow-y: scroll;"
        @scroll="handleScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          class="mt-1"
          hover
          selectable
          select-mode="single"
        >
          <template #cell(requested_date)="data">
            <span class="font-medium">{{ DAY_MONTH_YEAR(data.item.requested_date) }}</span>
            <br>
            <span class="text-sm text-[#828282]">
              {{ TIME(data.item.requested_date) }}
            </span>
          </template>
          <template #cell(partner_name)="data">
            <span class="font-medium">{{ data.item.partner_name }}</span>
            <br>
            <span class="text-sm text-[#828282]">{{ data.item.partner_email }}</span>
          </template>
          <template #cell(list_product)="data">
            <div class="d-flex gap-4 justify-center">
              <div
                v-for="(icon, idx) in data.value"
                :key="idx"
              >
                <img
                  :src="icon"
                >
              </div>
            </div>
          </template>
          <template #cell(file)="data">
            <span
              class="text-primary underline"
              @click="$router.push(`/verification-ktp/${data.item.id}/file/${data.item.partner_id}`)"
            >
              Lihat Berkas
            </span>
          </template>
          <template #cell(history)="data">
            <div
              class="flex flex-row items-center justify-center gap-4"
              @click="$router.push(`/verification-ktp/history/${data.item.id}`)"
            >
              <div class="text-primary underline">
                Lihat Riwayat
              </div>
              <BBadge
                variant="primary"
                style="border-radius: 50px"
              >
                {{ data.item.history_request_count }}
              </BBadge>
            </div>
          </template>
          <template #cell(status)="data">
            <div :class="getClassStatus(data.item.status)">
              {{ getLabelStatus(data.item.status) }}
            </div>
          </template>
        </BTable>
      </div>
    </BOverlay>
    <div class="w-2/3 my-1">
      <div class="text-sm">
        Note :
      </div>
      <span class="text-danger">*</span>
      <small class="text-xs">Verifikasi hanya untuk kebutuhan Komcards, Komship, Komads, Kompack, Komchat dan Komtim. Icon produk lain hanya sebagai informasi bahwa user juga memakai produk tersebut.</small>
    </div>
  </BCard>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vSelect from 'vue-select'
import {
  LABELDAY, LABELMONTH, YEAR_MONTH_DAY, DAY_MONTH_YEAR, TIME, DDMMYYYY,
} from '@/libs/filterDate'
import {
  firstDateOfMonth, last2, last7, today,
} from '@/store/helpers'
import { newAxiosIns } from '@/libs/axios'
import Ripple from 'vue-ripple-directive'
import secureLocalStorage from '@/libs/secureLocalstorage'
import {
  chooseStatus, configColumnPartner, getClassStatus, getLabelStatus, iconProduct, optionsProduct,
} from './config'
import Card from './Card.vue'

export default {
  components: { Card, DateRangePicker, vSelect },
  directives: {
    Ripple,
  },
  data() {
    return {
      last2,
      last7,
      today,
      firstDateOfMonth,
      chooseStatus,
      statusOptions: chooseStatus,
      status: (secureLocalStorage.get('statusVerificationKomcard') !== null && secureLocalStorage.get('statusVerificationKomcard') !== undefined)
        ? secureLocalStorage.get('statusVerificationKomcard')
        : '',
      product: (secureLocalStorage.get('productVerificationKomcard') !== null && secureLocalStorage.get('productVerificationKomcard') !== undefined)
        ? secureLocalStorage.get('productVerificationKomcard')
        : '',
      search: (secureLocalStorage.get('searchVerificationKomcard') !== null && secureLocalStorage.get('searchVerificationKomcard') !== undefined)
        ? secureLocalStorage.get('searchVerificationKomcard')
        : '',
      isResetting: false,
      loading: false,
      analytic: {},
      loadingCard: false,
      offset: 0,
      limit: 25,
      lastData: false,
      items: [],
      fields: configColumnPartner,
      iconOfProduct: iconProduct,
      optionsOfProduct: optionsProduct,
      DAY_MONTH_YEAR,
      TIME,
      YEAR_MONTH_DAY,
      DDMMYYYY,
      getClassStatus,
      getLabelStatus,
      dateRange: {
        startDate: secureLocalStorage.get('paramDateVerificationKomcardStartDate') ? secureLocalStorage.get('paramDateVerificationKomcardStartDate') : firstDateOfMonth,
        endDate: secureLocalStorage.get('paramDateVerificationKomcardEndDate') ? secureLocalStorage.get('paramDateVerificationKomcardEndDate') : today,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
    }
  },
  watch: {
    status: {
      handler(value) {
        secureLocalStorage.set('statusVerificationKomcard', value)
        if (!this.isResetting) this.getList()
      },
    },
    product: {
      handler(value) {
        secureLocalStorage.set('productVerificationKomcard', value)
        if (!this.isResetting) this.getList()
      },
    },
    dateRange: {
      handler(value) {
        secureLocalStorage.set('paramDateVerificationKomcardStartDate', YEAR_MONTH_DAY(value.startDate))
        secureLocalStorage.set('paramDateVerificationKomcardEndDate', YEAR_MONTH_DAY(value.endDate))
        if (!this.isResetting) this.getList()
      },
    },
    search: {
      handler(value) {
        secureLocalStorage.set('searchVerificationKomcard', value)
      },
    },
  },
  mounted() {
    this.getList()
    this.getAnalytic()
  },
  created() {
    window.onscroll = () => {
      if ((window.innerHeight + window.scrollY) >= document.getElementById('scroll').offsetHeight && !this.loading) {
        this.getNextData()
      }
    }
  },
  methods: {
    handleScroll() {
      const table = document.getElementById('table')
      if ((table.scrollTop >= table.scrollHeight - table.offsetHeight - 5) && !this.loading && !this.lastData) {
        this.getNextData()
      }
    },
    async getAnalytic() {
      this.loadingCard = true
      const url = '/auth/api/v1/admin/ktp-verification/dashboard'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.analytic = data
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal load data' })
        })
    },
    async getList() {
      this.loading = true
      this.offset = 0
      const defaultParams = {
        start_date: YEAR_MONTH_DAY(this.dateRange.startDate),
        end_date: YEAR_MONTH_DAY(this.dateRange.endDate),
        offset: this.offset,
        limit: this.limit,
        status: this.status,
        filter_products: this.product === '' ? [] : this.product,
      }

      const searchParams = {
        search: this.search,
      }

      const params = !this.search ? defaultParams : searchParams

      const url = '/auth/api/v1/admin/ktp-verification'
      await newAxiosIns.get(url, { params })
        .then(res => {
          const { data } = res.data
          data.forEach(item => {
            // eslint-disable-next-line no-param-reassign
            item.list_product = []

            iconProduct.forEach(type => {
              if (item[type.name]) {
                item.list_product.push(iconProduct.find(p => p.name === type.name).src)
              }
            })
          })
          this.loading = false
          this.offset = data.length
          this.items = data
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.loading = false
          this.$toast_error({ message: 'Gagal load data' })
        })
    },
    getNextData() {
      if (!this.lastData) {
        this.loading = true
        const params = {
          start_date: YEAR_MONTH_DAY(this.dateRange.startDate),
          end_date: YEAR_MONTH_DAY(this.dateRange.endDate),
          offset: this.offset,
          limit: this.limit,
          status: this.status,
          search: this.search,
          filter_products: this.product === '' ? [] : this.product,
        }
        const url = '/auth/api/v1/admin/ktp-verification'
        newAxiosIns.get(url, { params })
          .then(res => {
            const { data } = res.data
            data.forEach(item => {
            // eslint-disable-next-line no-param-reassign
              item.list_product = []

              iconProduct.forEach(type => {
                if (item[type.name]) {
                  item.list_product.push(iconProduct.find(p => p.name === type.name).src)
                }
              })
            })
            this.items.push(...data)
            this.offset += data.length
            this.loading = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(() => {
            this.loading = false
            this.$toast_error({ message: 'Gagal load data' })
          })
      }
    },
    searchData: _.debounce(function search(text) {
      this.getList()
    }, 1000),
    resetFilter() {
      this.isResetting = true
      this.status = ''
      this.product = ''
      this.dateRange = {
        startDate: firstDateOfMonth,
        endDate: today,
      }
      this.search = ''
      secureLocalStorage.set('statusVerificationKomcard', '')
      secureLocalStorage.set('productVerificationKomcard', '')
      secureLocalStorage.set('searchVerificationKomcard', '')
      secureLocalStorage.set('paramDateVerificationKomcardStartDate', YEAR_MONTH_DAY(firstDateOfMonth))
      secureLocalStorage.set('paramDateVerificationKomcardEndDate', YEAR_MONTH_DAY(today))
      this.$nextTick(() => {
        this.isResetting = false
        this.getList()
      })
    },
  },
}
</script>
<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.vue-daterange-picker {
  width: 100% !important;

  .reportrange-text {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 6px 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
}
</style>
